import { LEVELS } from "@package/map";

import { Card, Stack, Typography, Switch } from "@mui/material";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { toggleVisibility } from "Redux/inventorySlice";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { STATIONS3 } from "Constants/Stations";
import { changeMode, selectCarsTypes } from "Redux/fleetSlice";
import MenuButton from "./Button";

export default function Cars() {
  const dispatch = useAppDispatch();

  const { mode, carsTypes } = useAppSelector((state) => state.fleet);
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const setCarsMode = () => {
    if (mode === "cars") {
      dispatch(changeMode(null));
    } else {
      dispatch(changeMode("cars"));
    }
  };

  const handleClick = (type: any) => {
    dispatch(selectCarsTypes(type));
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          {STATIONS3.map((station) => (
            <MenuButton
              isActive={carsTypes.includes(station.type)}
              onClick={() => handleClick(station.type)}
              title={station.text}
            >
              {station.icon}
            </MenuButton>
          ))}
        </Stack>
        <Stack direction="row" style={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={setCarsMode} checked={mode === "cars"} />
        </Stack>
      </Stack>
    </Card>
  );
}
